var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"content-title"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-body"},[_c('h1',[_vm._v("\n          "+_vm._s(_vm.$t("feature.contact.title"))+"\n        ")]),_vm._v(" "),_c('breadcrumbs',{attrs:{"labels":_vm.breadcrumbsLabels}})],1)])]),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }